import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const fetchGroups = createAsyncThunk('fetchGroups', async (_, { getState, rejectWithValue }) => {
  try {
    const { data, status } = await api.get('/groups');
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch groups'));
  }
});

export const groupsSlice = createSlice({
  name: 'groups',
  initialState: {
    data: null,
    error: null
  },
  reducers: {
    updateError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroups.fulfilled, (state, action) => {
        state.data = action.payload.data;
      })
      .addCase(fetchGroups.rejected, (state, action) => {
        state.error = action.payload;
      });
  }
});

export const getGroups = (state) => state.groups.data;
export const getGroupsError = (state) => state.groups.error;

export { fetchGroups };

export const { updateError } = groupsSlice.actions;

export default groupsSlice.reducer;
